import { Input } from "@nextui-org/react";
import React, { useContext, useEffect, useState } from "react";
import emailIcon from "../../Assets/auth/sms.svg";
import passIcon from "../../Assets/auth/lock.svg";
import userIcon from "../../Assets/auth/user-square.svg";
import visibleEye from "../../Assets/auth/eye.svg";
import hiddenEye from "../../Assets/auth/eye-slash.svg";
import googleIcon from "../../Assets/auth/social/01.svg";
import appleIcon from "../../Assets/auth/social/04.svg";
import { Link, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useClerk, useSignIn, useSignUp } from "@clerk/clerk-react";
import { AuthContext } from "Context/AuthContext";
import { OAuthStrategy } from "@clerk/types";
import PrivacyPolicy from "components/PrivacyPolicy/PrivacyPolicy";
import TermsOfService from "components/TermsOfService/TermsOfService";

const Register = () => {
  const [isVisible, setIsVisible] = React.useState(false);

  const authInfo = [
    {
      method: "oauth_google",
      link: "https://google.com",
    },
    // {
    //   method: "oauth_facebook",
    //   link: "https://facebook.com",
    // },
    // {
    //     method: "oauth_x",
    //     link: "/",
    // },
    {
      method: "oauth_apple",
      link: "/",
    },
  ];

  const toggleVisibility = () => setIsVisible(!isVisible);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);

  const showPolicy = () => {
    setIsModalOpen(true);
  };

  const showTerms = () => {
    setIsTermsModalOpen(true);
  };

  //integration part

  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const navigate = useNavigate();

  const { signIn } = useSignIn();
  const { signUp, setActive } = useSignUp();

  const {
    setIsVerified,
    setRegisterFname,
    setRegisterLname,
    setRegisterEmail,
    setRegisterPass,
  } = useContext(AuthContext);

  const validationSchema = Yup.object({
    name: Yup.string()
      .matches(/^[a-zA-Z()]+((\s|-|_)[A-Za-z\(\)]+)*$/gi, "Invalid name")
      .min(3, "Name is too short")
      .max(60, "Name is too long")
      .required("Name required"),
    email: Yup.string().email("Invalid email").required("Email required"),
    password: Yup.string()
      .matches(
        /(?=.*[a-z])(?=.*[A-Z])(?=.*[\d])(?=.*[!@#$%^&*()_+[\]{};':"\\|,.<>/?`~-])/,
        "Password must contain small, capital, number and special character"
      )
      .min(8, "Weak password")
      .max(30, "Password is too long")
      .required("Password required"),
  });

  const registerForm = useFormik({
    initialValues: {
      name: "",
      email: "",
      password: "",
    },
    validationSchema,
    onSubmit: callRegister,
  });

  const { session } = useClerk();

  async function callRegister(reqBody) {
    if (session) {
      session?.end();
    }
    setErrorMessage("");
    setIsLoading(true);
    setIsDisabled(true);
    const first_name = reqBody.name.split(/[\s-_]+/)[0];
    const last_name =
      reqBody.name.split(" ").length >= 2
        ? reqBody.name.split(/[\s-_]+/)[1]
        : " ";

    try {
      await signUp.create({
        first_name,
        last_name,
        emailAddress: reqBody.email,
        password: reqBody.password,
      });

      // Send the user an email with the verification code
      await signUp.prepareEmailAddressVerification({
        strategy: "email_code",
      });
      setIsVerified(false);
      setRegisterFname(first_name);
      setRegisterLname(last_name);
      setRegisterEmail(reqBody.email);
      setRegisterPass(reqBody.password);
      navigate("/verify-password");
    } catch (error) {
      setErrorMessage(error.errors ? error.errors[0].message : error.message);
      setIsLoading(false);
    }
    setIsDisabled(false);
  }

  // OAuth

  const signInWith = (strategy, link) => {
    return signUp.authenticateWithRedirect({
      strategy,
      redirectUrl: "/sso-callback",
      redirectUrlComplete: "/loading",
    });
  };

  async function handleSignIn(strategy, link) {
    if (!signIn || !signUp) return null;

    // If the user has an account in your application, but does not yet
    // have an OAuth account connected to it, you can transfer the OAuth
    // account to the existing user account.
    const userExistsButNeedsToSignIn =
      signUp.verifications.externalAccount.status === "transferable" &&
      signUp.verifications.externalAccount.error?.code ===
        "external_account_exists";

    if (userExistsButNeedsToSignIn) {
      const res = await signIn.create({ transfer: true });

      if (res.status === "complete") {
        setActive({
          session: res.createdSessionId,
        });
      }
    }

    // If the user has an OAuth account but does not yet
    // have an account in your app, you can create an account
    // for them using the OAuth information.
    const userNeedsToBeCreated =
      signIn.firstFactorVerification.status === "transferable";

    if (userNeedsToBeCreated) {
      const res = await signUp.create({
        transfer: true,
      });

      if (res.status === "complete") {
        setActive({
          session: res.createdSessionId,
        });
      }
    } else {
      // If the user has an account in your application
      // and has an OAuth account connected to it, you can sign them in.
      signInWith(strategy, link);
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="signup font-Miranda flex justify-center items-start relative py-1">
      <div className="absolute bottom-0 left-0 sm:w-[450px] w-[80%] h-[412px] bg-authImg1 bg-cover bg-no-repeat z-0"></div>
      
      <div className="absolute top-[30px] right-0 w-[214px] h-[287px] bg-authImg2 bg-cover bg-no-repeat z-0"></div>
      
      <div className="container xl:px-44 sm:px-6 px-4 mx-auto relative z-10">
       
        <div className="box sm:mx-auto sm:w-[585px] w-auto  rounded-20px flex flex-col justify-center sm:p-10 p-5 relative z-20 bg-white ">
           <h1 className=" font-extrabold text-3xl justify-center text-center mb-2">Create account</h1>
          <h2 className=" text-md text-gray-500 font-Miranda mb-1 text-center">
            Seconds to join our family
          </h2>
          <div className="signup-form mb-9">
            {errorMessage && (
              <div className="text-white bg-cardColor py-3 mb-3 text-center rounded-15px text-sm">
                <span className="bg-clip-text text-transparent bg-mainGradiant font-bold">
                  {errorMessage}
                </span>
              </div>
            )}
            <form onSubmit={registerForm.handleSubmit}>
              <div className="mb-4">
                <Input
                  name="name"
                  type="text"
                  // label="Full Name"
                  variant="bordered"
                  placeholder="Full Name"
                  labelPlacement="outside"
                  // startContent={<img src={userIcon} alt="user icon" />}
                  classNames={{
                    placeholder: "text-[13.81px] font-normal mt-1",
                    input: "py-3 text-sm uppercase  placeholder:uppercase border-none",
                  }}
                  onChange={registerForm.handleChange}
                  onBlur={registerForm.handleBlur}
                  value={registerForm.values.name}
                  isInvalid={registerForm.errors.name}
                  errorMessage={
                    registerForm.errors.name && registerForm.touched.name
                      ? registerForm.errors.name
                      : null
                  }
                />
              </div>
              <div className="mb-4">
                <Input
                  name="email"
                  type="email"
                  // label="Email"
                  variant="bordered"
                  placeholder="Email"
                  labelPlacement="outside"
                  // startContent={<img src={emailIcon} alt="email icon" />}
                  classNames={{
                    label: "text-[13.81px] font-normal opacity-75 mt-1",
                    input: "border-none py-[10.36px]",
                  }}
                  onChange={registerForm.handleChange}
                  onBlur={registerForm.handleBlur}
                  value={registerForm.values.email}
                  isInvalid={registerForm.errors.email}
                  errorMessage={
                    registerForm.errors.email && registerForm.touched.email
                      ? registerForm.errors.email
                      : null
                  }
                />
              </div>
              <div className="mb-4">
                <Input
                  name="password"
                  // label="Password"
                  variant="bordered"
                  labelPlacement="outside"
                  placeholder="Password"
                  // startContent={<img src={passIcon} alt="password icon" />}
                  endContent={
                    <button
                      className="focus:outline-none"
                      type="button"
                      onClick={toggleVisibility}
                    >
                     {isVisible ? (
 
                      // Open eye (visible)
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 text-gray-500">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" />
                        <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                      </svg>
                    ) : (
                      // Closed eye (hidden)
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 text-gray-500">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88" />
                      </svg>
                    )}
                    </button>
                  }
                  type={isVisible ? "text" : "password"}
                  classNames={{
                    label: "text-[13.81px] font-normal opacity-75 mt-1",
                    input: "border-none py-[10.36px]",
                  }}
                  onChange={registerForm.handleChange}
                  onBlur={registerForm.handleBlur}
                  value={registerForm.values.password}
                  isInvalid={registerForm.errors.password}
                  errorMessage={
                    registerForm.errors.password &&
                    registerForm.touched.password
                      ? registerForm.errors.password
                      : null
                  }
                />
              </div>
              <button
                type="submit"
                disabled={
                  !(registerForm.isValid && registerForm.dirty) || isDisabled
                }
                className="w-full bg-mainGradiant h-[44px] text-white text-[15.54px] font-bold rounded-[12.95px]"
              >
                {isLoading ? (
                  <span className="flex gap-2 justify-center items-center">
                    <i className="fa-solid fa-spinner fa-spin text-white"></i>
                  </span>
                ) : (
                  "Start your plans"
                )}
              </button>
            </form>
          </div>
          <div className="font-semibold font-Miranda policy mb-5">
            <p className="text-center text-[13.81px]">
              By signing up, I accept
              <Link
                  to="/terms-of-service"
                  className="mx-1 bg-clip-text text-transparent bg-mainGradiant font-bold"
                >
                  Terms Of Service
                </Link>
                and acknowledge the
                <Link
                  to="/privacy-policy"
                  className="ms-1 bg-clip-text text-transparent bg-mainGradiant font-bold"
                >
                  Privacy Policy
                </Link>
            </p>
          </div>
          <div className="continue text-center flex gap-8 items-center justify-center mb-6">
            <span className="bg-cardGrayColor h-[0.86px] flex-grow"></span>
            <span className="text-cardGrayColor text-[13.81px]">
              Or continue with
            </span>
            <span className="bg-cardGrayColor h-[0.86px] flex-grow"></span>
          </div>
          <div className="grid grid-cols-2 gap-4 mb-6">
                <button
                  onClick={() => handleSignIn("oauth_google")}
                  className="flex items-center justify-center space-x-2 px-4 py-3 border border-gray-300 rounded-xl hover:bg-gray-50 transition-colors duration-200"
                >
                  <img src={googleIcon} alt="Google" className="w-5 h-5" />
                  <span className="text-sm font-medium text-gray-700">Google</span>
                </button>
                <button
                  onClick={() => handleSignIn("oauth_apple")}
                  className="flex items-center justify-center space-x-2 px-4 py-3 border border-gray-300 rounded-xl hover:bg-gray-50 transition-colors duration-200"
                >
                  <img src={appleIcon} alt="Apple" className="w-5 h-5" />
                  <span className="text-sm font-medium text-gray-700">Apple</span>
                </button>
              </div>
          <div className="sign-up text-center text-[13.81px]">
            Already have an account?
            <Link
              to={"/login"}
              className="ms-1 bg-clip-text text-transparent bg-mainGradiant relative after:absolute after:left-0 after:right-0 after:bottom-0 after:h-px after:bg-mainGradiant"
            >
              Log In
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Register;
